import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, DialogActions, DialogContent, TextField } from '@mui/material';
import { ModalActionProps } from 'models/AutoModals';
import { CarModel } from 'models/StockModel';


type ChangeChassisDialogProps = {
    car: CarModel,
} & ModalActionProps<string>

const ChangeChassisDialog = ({ car, onFinish }: ChangeChassisDialogProps) => {
    const {t} = useTranslation('cars');

    const submit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        onFinish(new FormData(event.currentTarget).get('chassisNumber') as string);
    };

    return (
        <Box component="form" onSubmit={submit}>
            <DialogContent>
                From: {car.chassisNumber}
                <TextField
                    id="chassisNumber"
                    name="chassisNumber"
                    label={t('new_chassis_number')}
                    fullWidth
                    required
                    autoFocus
                />
            </DialogContent>

            <DialogActions>
                <Button type="submit">{t('save')}</Button>
            </DialogActions>
        </Box>
    );
};

export default ChangeChassisDialog;
